import { render, staticRenderFns } from "./buyer.vue?vue&type=template&id=76dcf26a&scoped=true&"
import script from "./buyer.vue?vue&type=script&lang=js&"
export * from "./buyer.vue?vue&type=script&lang=js&"
import style0 from "./buyer.vue?vue&type=style&index=0&id=76dcf26a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76dcf26a",
  null
  
)

export default component.exports